var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',_vm._g(_vm._b({attrs:{"label":_vm.$attrs.label || 'Potência',"items":_setup.itens,"loading":_setup.carregando || _vm.$attrs.loading,"item-text":"nome","item-value":"_id","value":_vm.value},on:{"click:clear":() => _vm.$nextTick(() => _vm.$emit('input', null))}},'v-select',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }